import ViewBase from "../../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir } from "../../../../framework/tools/scrollview/listview";
import SpriteFrameHolder from "../../../public/ui/spriteFrameHolder";
import { stringify } from "querystring";
import ModuleManager from "../../../../framework/core/module_manager";

const {ccclass, property} = cc._decorator;

@ccclass
export  class RoadMap_yxx_view extends ViewBase {
    @property(cc.Animation)
    nodeRoots:cc.Animation[] = [];

    @property(cc.ScrollView)
    scrollview: cc.ScrollView[] = [];

    @property(cc.Node)
    statBtns: cc.Node[] = [];

    @property(cc.Node)
    view: cc.Node[] = [];

    @property(cc.Node)
    content: cc.Node[] = [];

    @property(cc.Node)
    prefab: cc.Node[] = [];

    @property(SpriteFrameHolder)
    iconSprFrameHolder:SpriteFrameHolder = null

    @property(cc.Label)
    probabilityLabels:cc.Label[] = []

    m_list: ListView[] = []
    dataList:number[] = []

    appearCount:number[] = [0,0,0,0,0,0]

    onLoad() {
        for(let i=0; i< this.scrollview.length; i ++){
            let list: ListView = new ListView({
                scrollview: this.scrollview[i],
                view: this.view[i],
                content: this.content[i],
                item_prefab: this.prefab[i],
                cb_host: this,
                item_update_func: (i == 0 ? this.update_list_item_0 : this.update_list_item_1),
                select_cb: this.on_item_select,
                column: 1,
                row: 1,
                gap_y: 10,
                direction:  (i == 0 ? ListViewDir.Horizontal : ListViewDir.Vertical) ,
            });
            this.m_list[i] = list
        }
        
    }
    
    on_item_select(data: any, index: number) {
        //cc.log(data, index);
    }


    updateShow(m_Data:any = null){
        if (m_Data == null){ return }
       
        this.dataList = m_Data 
        this.dataList = this.dataList.reverse()
        
        let showList = []
        for(let i =0; i< 10 ; i ++){
            if(this.dataList[i]){
                showList[i] = this.dataList[i]
            }
            
        }

        this.m_list[0].set_data( showList);
        this.m_list[0].select_item(1)
        this.m_list[0].scroll_to(0)

        this.m_list[1].set_data(showList);
        this.m_list[1].select_item(1)
        this.m_list[1].scroll_to(0)

        let tmp = null
        let oneRound = ""
        this.appearCount = [0,0,0,0,0,0]
        for(let i =0; i <  this.dataList.length; i ++){
            tmp = this.disposeData( this.dataList[i])
            
            oneRound = ""
            for(let j = 0; j < tmp.length; j ++){
                // if(oneRound.indexOf( String( tmp[j]-1) ) == -1 ){
                //     this.appearCount[ tmp[j]-1 ] += 1
                //     oneRound += String( tmp[j]-1)
                // }

                this.appearCount[ tmp[j]-1 ] += 1
                
            }
           
           
        }
        
        for(let i =0; i< this.probabilityLabels.length; i ++){
            let str = (this.appearCount[i] == 0 ? "0.0" : ((this.appearCount[i]*100 / (this.dataList.length*3) ) .toFixed(1))) + "%"
            this.probabilityLabels[i].string = str.replace(".", "&")
        }
    }

    update_list_item_0(item: cc.Node, data: any, index: number): void {
        let datas = this.disposeData(data)
        let icon = cc.find("icon1", item).getComponent(cc.Sprite)
        icon.spriteFrame = this.iconSprFrameHolder.getSpriteFrameByKey(datas[0]+"" )

        icon = cc.find("icon2", item).getComponent(cc.Sprite)
        icon.spriteFrame = this.iconSprFrameHolder.getSpriteFrameByKey(datas[1]+"" )

        icon = cc.find("icon3", item).getComponent(cc.Sprite)
        icon.spriteFrame = this.iconSprFrameHolder.getSpriteFrameByKey(datas[2]+"" )
    }

    update_list_item_1(item: cc.Node, data: any, index: number): void {
        
        let datas = this.disposeData(data)

        let icon:cc.Sprite = null
        let count:cc.Label = null
        let beishu:cc.Label = null

        let noOccurredCount =  this.getNoOccurredCount(index)
        
        for(let i =1 ;i < 7; i ++){
            icon =  cc.find(""+i, item).getComponent(cc.Sprite)
            icon.enabled = i == datas[0] || i == datas[1] || i == datas[2]

            beishu =  cc.find(i+"/beishubg/beishu", item).getComponent(cc.Label)
            if( (datas[0] ==  datas[1] &&  datas[0]== i) ||  (datas[0] ==  datas[2] && datas[0] == i)  ||  (datas[1] ==  datas[2] && datas[1] == i) ){
                beishu.node.parent.active = true
                if( datas[0] ==  i && datas[1] ==  i  &&  datas[2] == i){
                    beishu.string = 3 + ""
                }else{
                    beishu.string = 2 + ""
                }
            }else{
                beishu.node.parent.active = false
            }

            count =  cc.find(i+"/Label", item).getComponent(cc.Label)
            count.node.active = noOccurredCount[i-1] != -1
            count.string =  "" + (noOccurredCount[i-1] >10000?  (noOccurredCount[i-1] -10000): noOccurredCount[i-1])
        }
        
        
    }

    //拆出一局开出的结果  服务器给的值如“123” 表示这一局开出的结果为  1， 2, 3
    disposeData(data){
        let ret:number[] =[]
        let dataString = String(data)
        ret[0] = Number(dataString[0])
        ret[1] = Number(dataString[1])
        ret[2] = Number(dataString[2])
        return ret
    }

    //连续未出现的局数
    getNoOccurredCount(idx){
        let curData:number[] = this.disposeData(this.dataList[idx])
        let temp:number[] = []
        let ret :number[] = [1,1,1,1,1,1]
        ret[curData[0] -1] = -1
        ret[curData[1]-1] = -1
        ret[curData[2]-1] = -1
        for(let i = idx+1; i <this.dataList.length; i ++){
            temp = this.disposeData(this.dataList[i])
            for(let j = 0;j < 6 ;j ++){
                if(ret[j] != -1 && ret[j] < 10000) {
                    if( j != temp[0]-1 && j != temp[1]-1 && j != temp[2]-1){
                        ret[j] = ret[j] + 1
                    }else{
                        ret[j] = ret[j] +10000
                    }
                }

                
            }
        }

        // cc.log("@@@@getNoOccurredCount@@@@@",idx, ret)
        return ret
      
    }

}
